export function actionsDisabled(shipmentArray: number[]): boolean {
    return shipmentArray.length === 0 ? true : false;
}